import datafeedService from "@/stores/dataManager/apiServices/datafeedService"
import { convertData } from "@/stores/transformData/transformData"
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"

type IndexesState = {
    marketIndexInfo: any,
    marketIndexes: any
}

export const getSnapShotIndexesInfo = createAsyncThunk(
    'indexes/getSnapShotIndexesInfo',
    async () => {
        try {
            let params = {
                code: ''
            }
            const response: any = await datafeedService.getSnapShotIndexesInfo(params)
            const marketsInfo = convertData.processJSON_MarketInfos(response)
            return marketsInfo
        } catch (error) {
            console.log('ha_check_error', error);
            return {}
        }
    },
)

export const getSnapShotIndexes = createAsyncThunk(
    'indexes/getSnapShotIndexes',
    async () => {
        try {
            let params = {
                symbols: ''
            }
            const response: any = await datafeedService.getMarketHistory(params)
            // let data: any = convertData.parseSymbolsList(response)
            // console.log('getSymbolsList', response)
            return response
        } catch (error) {
            console.log('ha_check_error', error);
            return {}
        }
    },
)

const initialState: IndexesState = {
    marketIndexInfo: {},
    marketIndexes: {}
}

export const indexesSlice = createSlice({
    name: 'indexes',
    initialState,
    reducers: {
        updateMarketInfo: () => { },
        updateMarketHistory: () => { }
    },
    extraReducers(builder) {
        builder.addCase(getSnapShotIndexesInfo.fulfilled, (state, action: PayloadAction<any>) => {
            // console.log('fulfilled')
            state.marketIndexInfo = action.payload
        })

        builder.addCase(getSnapShotIndexes.fulfilled, (state, action: PayloadAction<any>) => {
            // console.log('fulfilled')
            state.marketIndexes = action.payload
        })
    },
})

// Action creators are generated for each case reducer function
export const { updateMarketInfo, updateMarketHistory } = indexesSlice.actions

export default indexesSlice.reducer